import React from 'react';

function ConfirmDialog({ 
  isOpen, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel', 
  onConfirm, 
  onCancel,
  type = 'danger' // 'danger', 'warning', 'info'
}) {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          confirmBg: 'linear-gradient(135deg, #ff4757, #c44569)',
          confirmShadow: '0 2px 8px rgba(255, 71, 87, 0.3)',
          iconColor: '#ff4757',
          icon: '⚠️'
        };
      case 'warning':
        return {
          confirmBg: 'linear-gradient(135deg, #f39c12, #e67e22)',
          confirmShadow: '0 2px 8px rgba(243, 156, 18, 0.3)',
          iconColor: '#f39c12',
          icon: '⚠️'
        };
      case 'info':
        return {
          confirmBg: 'linear-gradient(135deg, #3498db, #2980b9)',
          confirmShadow: '0 2px 8px rgba(52, 152, 219, 0.3)',
          iconColor: '#3498db',
          icon: 'ℹ️'
        };
      default:
        return {
          confirmBg: 'linear-gradient(135deg, #ff4757, #c44569)',
          confirmShadow: '0 2px 8px rgba(255, 71, 87, 0.3)',
          iconColor: '#ff4757',
          icon: '⚠️'
        };
    }
  };

  const typeStyles = getTypeStyles();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000,
      backdropFilter: 'blur(4px)'
    }}>
      <div className="card" style={{ 
        width: '400px', 
        margin: 0,
        textAlign: 'center'
      }}>
        <div style={{ 
          fontSize: '3rem', 
          marginBottom: '16px',
          color: typeStyles.iconColor
        }}>
          {typeStyles.icon}
        </div>
        
        <h3 style={{ 
          color: '#f0f0f0', 
          marginBottom: '16px',
          fontSize: '1.3rem',
          fontWeight: '600'
        }}>
          {title}
        </h3>
        
        <p style={{ 
          color: '#b0b0b0', 
          marginBottom: '32px',
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        
        <div style={{ display: 'flex', gap: '12px' }}>
          <button 
            onClick={onCancel}
            className="btn" 
            style={{ 
              flex: 1, 
              background: 'linear-gradient(135deg, #666, #555)',
              boxShadow: '0 2px 8px rgba(102, 102, 102, 0.3)'
            }}
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm}
            className="btn" 
            style={{ 
              flex: 1, 
              background: typeStyles.confirmBg,
              boxShadow: typeStyles.confirmShadow
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;